import { supabase } from './supabase';

// Sends a notification to every user in the given staff roles (director,
// manager, dba). Goes through the notify_staff database function because
// executives can neither look up staff profiles nor write to someone else's
// inbox directly — the old direct inserts were silently refused.
export async function notifyStaff(roles, { type, title, body = null, companyId = null, relatedExecId = null }) {
  const { error } = await supabase.rpc('notify_staff', {
    p_roles: roles, p_type: type, p_title: title, p_body: body,
    p_company_id: companyId, p_related_exec_id: relatedExecId,
  });
  if (error) console.warn('notify_staff failed — has PHASE_9_workflow_fixes.sql been run?', error.message);
  return { error };
}

// Alerts directors about sequences that have gone overdue since the last run.
// Safe to call on every app load: each due date is only reported once.
export async function notifyOverdueSequences() {
  const { error } = await supabase.rpc('notify_overdue_sequences');
  if (error) console.warn('notify_overdue_sequences failed — has PHASE_9_workflow_fixes.sql been run?', error.message);
}
